import type {
  ApiEnvironment,
  ApiUser,
} from 'api/userEnvironment/types/ApiUserEnvironment';
import type { I18nLocale } from 'i18n/types/I18nLocale';
import { getEmbedSearchWidgetIdFromPathname } from 'modules/embedSearchWidget/utils/getEmbedSearchWidgetIdFromPathname';
import { registerMixpanelProperties } from 'utils/analytics/helpers/mixpanel';
import { configureAnalyticsUserData } from 'utils/analytics/setup/configureAnalyticsUserData';
import { configureTrackJs } from 'utils/configureTrackJs';
import { trackReferrals } from 'utils/trackReferral';

type Args = {
  user: ApiUser | null;
  environment: ApiEnvironment;
  locale: I18nLocale;
};

export function configureTracking({ user, environment, locale }: Args) {
  // Tracking
  configureTrackJs(user ? user.id : null);
  configureAnalyticsUserData({ user, environment, locale });

  const embedSearchWidgetId = getEmbedSearchWidgetIdFromPathname(
    window.location.pathname,
  );
  if (embedSearchWidgetId)
    registerMixpanelProperties({ embed_search_widget_id: embedSearchWidgetId });

  trackReferrals();
}
